import {Component} from '@angular/core';
import {InfoModalComponent} from "app/views/modal/info_modal.component";

@Component({
	templateUrl: './attach_domain_details.component.html'
})
export class AttachDomainDetailsComponent extends InfoModalComponent {
	detailLoader: boolean = false;
	details: any;
	
	ok() {
		this.close();
	}
}
